import { render, staticRenderFns } from "./ImageDrawer.vue?vue&type=template&id=ffa72888&scoped=true"
import script from "./ImageDrawer.vue?vue&type=script&lang=js"
export * from "./ImageDrawer.vue?vue&type=script&lang=js"
import style0 from "./ImageDrawer.vue?vue&type=style&index=0&id=ffa72888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa72888",
  null
  
)

export default component.exports